import React from "react";

function PaymentFailure(props) {
  const { t,values } = props;
  const { locale } = values;
  const raiseEnquiry = () => {

    if(locale === "ar")
      {
        window.open(
          process.env.REACT_APP_EMIRATESPOST_BASE_URL + "/ar/contact-us/raise-an-enquiry",
          "_blank"
        );
      }
      else
      {

        window.open(
          process.env.REACT_APP_EMIRATESPOST_BASE_URL + "/contact-us/raise-an-enquiry",
          "_blank"
        );
      }
   
  };
  return (
    <div className="row justify-content-sm-center mt-5">
      <div className="col-sm-12 col-md-8">
        <div className="payment-summary p-4">
          <div className="row">
            <div className="col-sm-12 col-lg-4">
              <div className="row">
                <div className="col-sm-12">
                  <img
                    src="./images/payment-failure.svg"
                    alt="payment success"
                    className="success-icon"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-lg-8">
              <div className="row payment-unsuccessful">
                <div className="col-sm-12 mt-md-5">
                  <h2>{t("PAYMENT_UNSUCCESSFUL")}</h2>
                </div>
                <div className="col-sm-12">
                  <p>{t("RAISE_ENQUIRY_INFO")}</p>
                </div>
                <div className="col-sm-12 my-4">
                  <button
                    className="btn btn-primary btn-awb-download"
                    onClick={raiseEnquiry}
                  >
                    {t("RAISE_AN_ENQUIRY")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentFailure;
